module.exports = __webpack_public_path__ + "static/img/low-profile-frame-with-wood-post-mounts.b2a7610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/duraframes/low-profile-frame-with-wood-post-mounts.jpg
// module id = 730
// module chunks = 0